import { Injectable } from '@angular/core';
import { RaintreeResponse, SendEmailOTPResponse, SendMobileOTPResponse, SignUpResponse, VerifyEmailOTPResponse, VerifyMobileOTPResponse, VerifySignUpResponse } from '../interfaces/raintree-response';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root',
})
export class AuthTransmissionService extends ApiService
  {
    public getAuthToken(loginFormPayload: any): Observable<RaintreeResponse> {
      return this.post<RaintreeResponse>(ROUTES.SIGNIN,{
        body: loginFormPayload,
      },false)
    }
    public getAuthSignUp(SignUpFormPayload: any): Observable<SignUpResponse> {
      return this.post<SignUpResponse>(ROUTES.SIGNUP,{
        body: SignUpFormPayload,
      },false)
    }
    public getSentEmailOTP(EmailId: any): Observable<SendEmailOTPResponse> {
      return this.post<SendEmailOTPResponse>(ROUTES.SEND_EMAIL_OTP,{
        body: EmailId,
      },false)
    }
    public getVerifyEmailOTP(VerifyEmailId: any): Observable<VerifyEmailOTPResponse> {
      return this.post<VerifyEmailOTPResponse>(ROUTES.VERIFY_EMAIL_OTP,{
        body: VerifyEmailId,
      },false)
    }
    public getSentMobileOTP(mobile: any): Observable<SendMobileOTPResponse> {
      return this.post<SendMobileOTPResponse>(ROUTES.SEND_MOBILE_OTP,{
        body: mobile,
      },false)
    }
    public getVerifyMobileOTP(VerifyMobile: any): Observable<VerifyMobileOTPResponse> {
      return this.post<VerifyMobileOTPResponse>(ROUTES.VERIFY_MOBILE_OTP,{
        body: VerifyMobile,
      },false)
    }
    public getVerifySignUp(VerifySignUp: any): Observable<VerifySignUpResponse> {
      return this.post<VerifySignUpResponse>(ROUTES.VERIFY_SIGNUP,{
        body: VerifySignUp,
      },false)
    }

    
    public getForgotPasswordSendCode(ForgotPassSendCode: any): Observable<VerifySignUpResponse> {
      return this.post<VerifySignUpResponse>(ROUTES.FORGOT_PASS_SEND_CODE,{
        body: ForgotPassSendCode,
      },false)
    }
    
    public getForgotPasswordVerifyCode(ForgotPassVerifyCode: any): Observable<VerifySignUpResponse> {
      return this.post<VerifySignUpResponse>(ROUTES.FORGOT_PASS_VERIFY_CODE,{
        body: ForgotPassVerifyCode,
      },false)
    }
    
    public fetchUserLoc(reqData: any): Observable<any> {
      return this.post<any>(ROUTES.USER_LOC,{
        body: reqData
      }  
      );
    
    }
    
  }

